module.exports = __webpack_public_path__ + "media/images/archi-17-291c9504.jpeg";